var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgPen = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 24 26",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.979 0a.581.581 0 0 0-.413.17l-5.971 5.971a.595.595 0 0 0-.01.816.595.595 0 0 0 .817 0L18.97 1.39l.618.619L1.496 20.101a2.446 2.446 0 0 0-.709 1.659A1.897 1.897 0 0 0 .59 23.39l-.529 1.022a.585.585 0 0 0 .099.664c.17.17.458.215.672.107l1.013-.529a1.92 1.92 0 0 0 1.64-.197 2.457 2.457 0 0 0 1.66-.708L23.64 5.254a.597.597 0 0 0 0-.816C22.212 3.013 20.794 1.601 19.373.17a.58.58 0 0 0-.395-.17Zm-3.255 7.486 2.035 2.035L4.338 22.943c-.272.27-.631.388-1.005.368a.58.58 0 0 0-.394.134c-.23.191-.559.215-.843.063a.579.579 0 0 0-.296-.063.576.576 0 0 0-.063-.287c-.151-.285-.126-.623.063-.851a.58.58 0 0 0 .126-.395 1.29 1.29 0 0 1 .376-.995v-.009L15.724 7.486Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.512 19.431c-1.39-.004-2.673.146-3.501.492-.266.11-.508.233-.694.508-.187.274-.163.753.027 1.02.38.531 1.002.763 2.097 1.102 1.035.32 2.06.706 2.697 1.062.237.131.416.266.515.356a2.617 2.617 0 0 1-.576.234c-.465.133-1.161.26-2.11.364-1.895.205-4.802.317-9.021.275a.574.574 0 1 0-.012 1.147c4.245.042 7.181-.067 9.158-.282.988-.107 1.735-.238 2.302-.401.567-.163.97-.328 1.257-.68.144-.177.24-.428.227-.67a1.098 1.098 0 0 0-.232-.598c-.237-.317-.56-.531-.949-.748-.777-.433-1.84-.822-2.916-1.155-.581-.18-.99-.377-1.233-.511.71-.249 2.453-.43 4.078-.33a.574.574 0 1 0 .071-1.146 20.314 20.314 0 0 0-1.185-.039Z"
  })));
};
export { SvgPen as ReactComponent };